import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from '@/app'
import { env } from '@/env.client'
import { router } from '@/router'

const isProduction = import.meta.env.PROD
const hasSentryDsn = Boolean(env.VITE_SENTRY_DSN)
const isSentryEnabled = isProduction && hasSentryDsn

if (isSentryEnabled) {
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
    tracesSampleRate: 1.0,
  })
}

const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
